<script lang="ts" setup>
import closeIcon from '@/assets/img/icon/close-icon.svg';
import { defineProps, ref, watch } from 'vue';

const props = defineProps({
  modelValue: { type: Boolean, required: true }, // for v-model
  width: { type: [Number, String], default: 400 },
});

const showDialog = ref(props.modelValue);
watch(
  () => props.modelValue,
  (val) => (showDialog.value = val)
);

const emits = defineEmits<{
  (e: 'close'): void;
}>();

const handleClose = () => {
  emits('close');
};
</script>

<template>
  <v-dialog persistent v-model="showDialog" :width="width">
    <div class="mb-3">
      <v-btn class="circle-btn" @click="handleClose">
        <v-img :src="closeIcon" width="14" height="14" />
      </v-btn>
    </div>
    <v-card>
      <slot name="body" />
      <slot name="actions" />
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.v-dialog {
  :deep(.v-card) {
    border-radius: 32px !important;
  }
}
</style>
